import React, { useState, createContext } from 'react';
import { Loader } from '../components/Loader';

export const LoaderContext = createContext();

export const LoaderProvider = (props) => {

    const { children } = props;
    const [ openLoader, setOpenLoader ] = useState(true);

    return (
        <LoaderContext.Provider value={{ setOpenLoader }}>
            <Loader isLoading={ openLoader } />
            { children }
        </LoaderContext.Provider>
    );
}